import { partial } from "lodash";
import { useIntl } from "react-intl";

import { useSendMessage, useSendNotificationsToAllChatMembers } from "~/hooks";
import { useCloseConversationPoll, useDeleteConversationPoll } from "~/queries";
import { PollResponseData } from "~/queries/chat/poll/useChatConversationPoll";
import { useChatAuthUserData } from "~/ui/context";

export const useTerminatePoll = (
  poll: PollResponseData | undefined,
  chatId: number,
  shouldNotShowAction: boolean
) => {
  const {
    mutateAsync: deletePoll,
    isLoading: isDeletingPoll,
  } = useDeleteConversationPoll();

  const {
    mutateAsync: closePoll,
    isLoading: isClosingPoll,
  } = useCloseConversationPoll();
  const intl = useIntl();

  const { chatAuthUser } = useChatAuthUserData();
  const { sendMessage } = useSendMessage(chatId);
  const { sendNotificationToAllMembers } = useSendNotificationsToAllChatMembers(
    chatId
  );
  const handleDeletePoll = () => {
    if (!poll?.poll) return;

    const id = shouldNotShowAction
      ? 3
      : Number(chatAuthUser?.user?.uid?.substring(1));
    if (chatAuthUser?.user?.uid?.substring(1) !== `${id}`) return;
    if (
      confirm(
        intl.formatMessage({
          defaultMessage: "Are you sure you want to delete this poll?",
          id: "O9e31e",
        })
      )
    ) {
      deletePoll([chatId, id]).then(() => {
        const message = `Poll: ${poll.poll.title} was deleted.`;
        sendMessage(message, partial(sendNotificationToAllMembers, message));
      });
    }
  };
  const handleClosePoll = () => {
    if (!poll?.poll) return;
    const id = shouldNotShowAction
      ? 3
      : Number(chatAuthUser?.user?.uid?.substring(1));
    if (chatAuthUser?.user?.uid?.substring(1) !== `${id}`) return;
    if (
      confirm(
        intl.formatMessage({
          defaultMessage: "Are you sure you want to close this poll?",
          id: "k3PZfv",
        })
      )
    ) {
      closePoll([chatId, id]).then(() => {
        const hasYesWon = poll.yes > poll.no;
        const yesMessage = `Voted option is YES with ${poll.yes} ${
          poll.yes === 1 ? "votes" : "vote"
        }. Option NO had ${poll.no} ${poll.no === 1 ? "vote" : "votes"}.`;
        const noMessage = `Voted option is NO with ${poll.no} ${
          poll.no === 1 ? "votes" : "vote"
        }. Option YES had ${poll.yes} ${poll.yes === 1 ? "votes" : "vote"}.`;
        const message = `Poll: ${poll.poll.title} was closed. ${
          hasYesWon ? yesMessage : noMessage
        }`;
        sendMessage(message, partial(sendNotificationToAllMembers, message));
      });
    }
  };

  return { handleClosePoll, handleDeletePoll, isDeletingPoll, isClosingPoll };
};
